import { ReactElement } from 'react';

import globalStyles from 'assets/styles/global.module.scss';
import { Card, Headline2, Lock, MainContainer, Text, Util } from 'views/components';

const AccessDenied = (): ReactElement => (
  <MainContainer>
    <div className={globalStyles['no-data-card']}>
      <Card cardPadding="2.5rem" maxWidth="480px" textAlign="center">
        <Util marginBottom="16px">
          <Lock />
        </Util>
        <Util marginBottom="16px">
          <Headline2>You don&apos;t have access to this page</Headline2>
        </Util>
        <Text align="center">
          This information is not available for your organization or role.
        </Text>
      </Card>
    </div>
  </MainContainer>
);

export { AccessDenied };
